import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import { fullMonths } from '../../../helpers/localization/localizationUtils';

const DatePickerCaption = (props) => {
  const { date, locale } = props;
  const { direction, theme, translate, localizationData } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const dtpClassName = `${className} front10-date-selector-caption`;

  const monthsLabels = fullMonths(translate, localizationData);

  return (
    <Box {...props} tabIndex={0} className={dtpClassName} style={style}>
      <span className="fr-ml-3 fr-mr-3">{monthsLabels[date.getMonth()]}</span>
      <span>
        {date.toLocaleDateString(locale, {
          year: 'numeric',
        })}
      </span>
    </Box>
  );
};

DatePickerCaption.propTypes = {
  date: PropTypes.objectOf(PropTypes.any).isRequired,
  localizationUtils: PropTypes.objectOf(PropTypes.any).isRequired,
  locale: PropTypes.string.isRequired,
  /**
   * Font size on the componet
   */
  fontSize: PropTypes.string,
  /**
   * Text align props
   */
  textAlign: PropTypes.string,
};

DatePickerCaption.defaultProps = {
  fontSize: '4',
  textAlign: 'center',
};
export default DatePickerCaption;
